import { useEffect } from "react";

export default function ChamUpload() {

    useEffect(() => {
        
            let uploadButton = document.querySelector('im-upload-button');

            uploadButton.addEventListener('gotfile', function (e) {
                document.getElementById("loadScreen").style.display = "block";
            });

            uploadButton.addEventListener('gotspecifier', function (e) {
                console.log("upload complete", e.value);
                window.location.href = `/visualizer/spec/${encodeURIComponent(e.value.Specifier)}/sel/-1`;
            });
      }, []); 

    return(
    <im-upload-button></im-upload-button>
    );
}

export function ChamUploadButton({className, title}) {

    const handleClick = function() {
        document.querySelector("im-upload-button").click();
        
    }

    return(
        <button onClick={handleClick} className={className}>{title}</button>
    )
}